// @mui
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Breakpoint } from "@mui/material";

// ----------------------------------------------------------------------

export enum QUERY_TYPE {
	UP = "up",
	DOWN = "down",
	BETWEEN = "between",
}

export default function useResponsive(query: QUERY_TYPE, start: Breakpoint, end?: Breakpoint) {
	const theme = useTheme();

	const mediaUp = useMediaQuery(theme.breakpoints.up(start));

	const mediaDown = useMediaQuery(theme.breakpoints.down(start));

	let mediaBetween = useMediaQuery(theme.breakpoints.between(start, end ?? "lg"));
	mediaBetween = end ? mediaBetween : false;
	const mediaOnly = useMediaQuery(theme.breakpoints.only(start));

	if (query === "up") {
		return mediaUp;
	}

	if (query === "down") {
		return mediaDown;
	}

	if (query === "between") {
		return mediaBetween;
	}

	return mediaOnly;
}

// ----------------------------------------------------------------------

export function useWidth() {
	const theme = useTheme();

	const sm = useMediaQuery(theme.breakpoints.up("sm"), { noSsr: true });
	const md = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true });
	const lg = useMediaQuery(theme.breakpoints.up("lg"), { noSsr: true });
	const xl = useMediaQuery(theme.breakpoints.up("xl"), { noSsr: true });

	if (xl) return "xl";
	if (lg) return "lg";
	if (md) return "md";
	if (sm) return "sm";
	return "xs";
}
